










import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import pregunta from './curso-resultado-pregunta.vue';
import { Curso } from '@/__env/lib/Cursos';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
@Component( {
    name: "Componente",
    props: {},
    components: {
        pregunta,
    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado; }

    async created()
    {

        console.log( this.Resultado.Respuestas );
    }

}
